import React from 'react';
import { Link } from "react-router-dom";
import { BWHeader, getStyle, space6 } from "../dist/helpers";
import playgroundScreenshot from "../images/bulba/games/Playground2.png";
import snakeScreenshot from "../images/bulba/games/Snake.png";

const GameCard = ({ dark, to, title, description, screenshot }) => (
  <div className="container" style={{ maxWidth: "500px", marginBottom: "2rem" }}>
    <Link to={to} style={{ textDecoration: "none" }}>
      <div
        className="p-4"
        style={{
          ...getStyle(dark),
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
          cursor: "pointer",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = "scale(1.03)";
          e.currentTarget.style.boxShadow = "0px 8px 20px DarkSlateGray";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0px 5px 10px DarkSlateGray";
        }}
      >
        <h2 className={`fw-bold ${dark ? "text-white" : ""}`}>{title}</h2>
        <p className={`mb-0 ${dark ? "text-white" : ""}`}>{description}</p>
        {screenshot && (
          <img
            src={screenshot}
            alt={`${title} preview`}
            style={{
              width: "100%",
              marginTop: "1rem",
              borderRadius: "6px",
              display: "block",
              objectFit: "cover",
            }}
          />
        )}
      </div>
    </Link>
  </div>
);

export default function Games({ dark }) {
  return (
    <div>
      <center>
        {BWHeader(dark, "Games", "Pick a game and start playing!")}
        <br />
        <GameCard
          dark={dark}
          to="/playground"
          title="🕹️ Playground"
          description="An open-ended playground game to explore and experiment."
          screenshot={playgroundScreenshot}
        />
        <GameCard
          dark={dark}
          to="/pokesnake"
          title="🐍 PokeSnake"
          description="A Pokémon-themed snake game — eat, grow, and chase the high score!"
          screenshot={snakeScreenshot}
        />
        <br />
        <br />
        {BWHeader(dark, "Experimental", "WIP!")}
        <br />
        <GameCard
          dark={dark}
          to="/pokedex"
          title="🧪 Full Pokédex"
          description="A sandbox for new ideas and features in progress."
        />
        <GameCard
          dark={dark}
          to="/xpComponent"
          title="🧪 XP Component"
          description="A sandbox for new ideas and features in progress."
        />
        <GameCard
          dark={dark}
          to="/Win98theme"
          title="🧪 Win 98 Theme"
          description="A sandbox for new ideas and features in progress."
        />
        {space6}
      </center>
    </div>
  );
}
